import e from "./ghl-ui.es1235.js";
var t = e(Object, "create");
const r = t;
export {
  r as default
};
